module.exports = __webpack_public_path__ + "img/platinum.dbc22048.svg";